import Toggler from 'components/shared/FormAdapters/FormDefault/Toggler';
import Text from 'components/shared/Typography/Text';

import s from './index.module.css';
import * as types from './types';

export const TogglerAdapter = (props: types.ITogglerAdapterProps) => {
  const { checked, isDisabled, onChange, theme, errorMessage, label, className, checkboxClassName } = props;

  return (
    <div className={s.wrapper}>
      <Toggler
        theme={theme}
        checked={checked}
        onChange={onChange}
        disabled={isDisabled}
        isError={!!errorMessage}
        noMargin
        className={className}
        checkboxClassName={checkboxClassName}
      />

      <Text>{label}</Text>
    </div>
  );
};
